import DealsMain from 'components/featured/Deals';
import { useParams } from 'react-router-dom';

const Deals = () => {
  const params = useParams();

  return <DealsMain />;
};

export default Deals;
